module.exports = __webpack_public_path__ + "static/media/logo_ministerioPublico.f21419f1.png";